export default {
  'Add Cut': 'काटें डालें',
}